module.exports = __webpack_public_path__ + "img/img1.b4a8df37.png";